import { useParams, Navigate } from '@tanstack/react-router';
import { useUserRoles } from '@anytag/auth';
import { Header } from '@anytag/shared-molecules';
import { EditInfluencerForOthers } from './edit-influencer-for-others';
import { EditInfluencerForTalentAgency } from './edit-influencer-for-talent-agency';

export const InfluencerDetails = () => {
  const params = useParams({ from: '/_private-routes/influencer/$id' });
  const { isTalentAgency, isAdminStaffPartner } = useUserRoles();

  const influencerId = params?.id ? Number(params?.id) : undefined;

  if (!influencerId) {
    return <Navigate to="/influencer/add" />;
  }

  return (
    <div>
      <Header />

      {isTalentAgency ? (
        <EditInfluencerForTalentAgency influencerId={influencerId} />
      ) : isAdminStaffPartner ? (
        <EditInfluencerForOthers influencerId={influencerId} />
      ) : (
        <Navigate to="/influencer/add" />
      )}
    </div>
  );
};
